/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserProfileLinkDto = {
  id: number;
  linkType: UserProfileLinkDto.linkType;
  title?: string;
  url: string;
  ordering: number;
};
export namespace UserProfileLinkDto {
  export enum linkType {
    INSTAGRAM = "INSTAGRAM",
    YOUTUBE = "YOUTUBE",
    X_TWITTER = "X_TWITTER",
    FACEBOOK = "FACEBOOK",
    TIKTOK = "TIKTOK",
    LINKEDIN = "LINKEDIN",
    WEBSITE = "WEBSITE",
    NAVER_BLOG = "NAVER_BLOG",
    NAVER_CAFE = "NAVER_CAFE",
    KYOBO = "KYOBO",
    YES24 = "YES24",
    ETC = "ETC",
  }
}
